export default "__VITE_ASSET__CCiYWSYY__"